$(document).on("pubgm_mainsite_header rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    swiperKv = new Swiper(".kv_swiper", {
        // autoplay: {
        //     delay: 5e3,
        //     disableOnInteraction: !1
        // },
        effect: "fade",
        slidesPerView: 1,
        spaceBetween: 30,
        loop: !0,
        observeParents: !0,
        observer: !0,
        noSwiping: !1,
        pagination: {
            el: ".swiper-pagination.pagination_event",
            clickable: true
        },
        on: {
            transitionStart: function () {
                var e = this.realIndex;
                $(".tag_list .tag_item").eq(e).addClass("on").siblings().removeClass("on");
                $(".banner_list .banner_item").eq(e).addClass("on").siblings().removeClass("on");
                $(".page_list .page_item").eq(e).addClass("on").siblings().removeClass("on");
            }
        }
    });

    // Gắn event click cho banner_item
    $(".banner_item").on("click", function () {
        var e = $(this).index();
        swiperKv.slideTo(e + 1);
    });

    // Gắn event click cho nút enter
    $(".btn_enterswiper").on("click", function (e) {
        // gtag("event", "x_click", {
        //     event_category: "banner_enter",
        //     event_label: $(".banner_item.on").attr("data-link")
        // });
        window.location.href = $(".banner_item.on").attr("data-link");
        e.stopPropagation();
    });

    // Gắn event click cho slide chính
    $(".kv_swiper .swiper-slide").on("click", function (e) {
        // gtag("event", "x_click", {
        //     event_category: "swiper_enter",
        //     event_label: $(".banner_item.on").attr("data-link")
        // });
        window.location.href = $(".banner_item.on").attr("data-link");
        e.stopPropagation();
    });
});
